import { Link } from "react-router-dom";
import { Flame, ArrowRight, Calendar, Globe, MapPin } from "lucide-react";
import { BrutalButton, BrutalCard } from "../common/Brutal";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_campground-command/artifacts/j9ipkx75_kaogmafestivalinfobanner.jpg";

export const LandingHero = () => (
  <section className="relative">
    <div className="absolute inset-0">
      <img src={HERO_IMG} alt="Festival crowd" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-br from-[#3D1E6D]/85 via-[#5B2B82]/70 to-[#E5247C]/60" />
    </div>
    <div className="relative max-w-7xl mx-auto px-4 py-20 sm:py-28 grid lg:grid-cols-12 gap-8 items-end">
      <div className="lg:col-span-8 text-white">
        <div className="inline-flex items-center gap-2 bg-[#E5247C] kf-border kf-shadow px-3 py-1.5 mb-4">
          <Flame className="h-4 w-4" strokeWidth={2.75} />
          <span className="text-xs font-bold tracking-[0.25em] uppercase">May 26–31 · 2026</span>
        </div>
        <h1 className="display text-6xl sm:text-7xl lg:text-8xl leading-[0.85]">
          The Hottest
          <br />
          <span className="kf-rainbow-text">Festival</span> in
          <br />
          the World.
        </h1>
        <p className="mt-6 max-w-xl text-lg text-white/90 font-medium">
          Fuel the fire and feel the beat! We’re bringing six days of absolute tropical mayhem to CamSur Uptown. From sunset sets to sunrise rhythms, this is where the world’s hottest festival lives.
        </p>
        <p className="mt-3 max-w-xl text-lg text-white/90 font-medium">
          Pitch your tent, park your rig at the Kaogma Grounds Campsite, and get lost in the sound. The chaos is calling—are you ready?
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/login" data-testid="hero-book-now">
            <BrutalButton variant="secondary">
              Book a Camping Slot <ArrowRight className="h-4 w-4" />
            </BrutalButton>
          </Link>
          <a href="#map">
            <BrutalButton variant="dark">View Campsite Map</BrutalButton>
          </a>
        </div>
      </div>
      <div className="lg:col-span-4 grid grid-cols-3 gap-3">
        {[
          { icon: Calendar, label: "6 Days" },
          { icon: Globe, label: "Local & Int’l" },
          { icon: MapPin, label: "4 Zones" },
        ].map(({ icon: Icon, label }, i) => (
          <BrutalCard key={i} className="p-4 text-center">
            <Icon className="h-6 w-6 mx-auto text-[#E5247C]" strokeWidth={2.75} />
            <div className="display text-xl mt-2 text-[#3D1E6D]">{label}</div>
          </BrutalCard>
        ))}
      </div>
    </div>
  </section>
);
